module.exports = __webpack_public_path__ + "static/media/app_store.b046dd41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_store.svg
// module id = 1243
// module chunks = 0